import { render, staticRenderFns } from "./widget_quick_links.vue?vue&type=template&id=37a270de&"
import script from "./widget_quick_links.vue?vue&type=script&lang=js&"
export * from "./widget_quick_links.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports